export default __webpack_public_path__ + "static/media/Conditions.10a33d42.pdf";